var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styles from './AddressPage.module.css';
import { useCallback, useState } from 'react';
import { PageLayout } from '../../Components/PageLayout';
import { Input } from '../../Components/BaseComponents/Input';
import { useApplication, useOrder } from '../../Contexts/ApplicationContext';
import { observer } from 'mobx-react-lite';
import { getNonEditableDefaultValue, useNFT, useSettings, } from '../../Contexts/SettingsContext';
import { useAnalytics } from '../../Contexts/AnalyticsContext';
import { useMetaMask } from './ExtensionAddressButton';
import { savedAddress } from '../../../Services/savedWalletAddress';
export var AddressPageFirstScreen = observer(function (_a) {
    var _b;
    var walletCreationProps = _a.walletCreationProps;
    var orderFacade = useApplication().orderFacade;
    var amounts = useOrder().amounts;
    var defaultValues = useSettings().defaultValues;
    var smartContractData = useNFT();
    var _c = useAnalytics(), track = _c.track, identify = _c.identify;
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var addressFromDefault = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.targetAddress;
    var toCurrency = (_b = amounts === null || amounts === void 0 ? void 0 : amounts.to) === null || _b === void 0 ? void 0 : _b.currency;
    var _e = useState(orderFacade.userInfo.address ||
        (addressFromDefault === null || addressFromDefault === void 0 ? void 0 : addressFromDefault.value) ||
        savedAddress(toCurrency)), address = _e[0], setAddress = _e[1];
    var _f = useState(), error = _f[0], setError = _f[1];
    var handleChange = useCallback(function (e) {
        if (error) {
            setError(undefined);
        }
        setAddress(e.target.value);
    }, [error]);
    var _g = useMetaMask({
        onSuccess: function (v) {
            setError(undefined);
            setAddress(v);
        },
        onError: setError,
        currency: toCurrency,
        address: address,
    }), ExtensionBtn = _g.ExtensionBtn, metaMaskAddress = _g.metaMaskAddress, ZeroIdAgreementBlock = _g.ZeroIdAgreementBlock, issueZeroId = _g.issueZeroId;
    var handleSubmit = useCallback(function () {
        setLoading(true);
        orderFacade
            .sendAddress(address, issueZeroId)
            .then(function () {
            identify({ wallet: address });
            track('wallet_submitted', {
                wallet_address: address,
                wallet_address_metamask: metaMaskAddress,
            });
        })
            .catch(function (err) {
            var _a, _b;
            var serverError = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            var errorText = (serverError === null || serverError === void 0 ? void 0 : serverError.includes('Invalid address'))
                ? serverError
                : 'Something went wrong. Please, try again.';
            setError(errorText);
            track('error_raised', { error: errorText });
        })
            .finally(function () {
            setLoading(false);
        });
    }, [orderFacade, address, issueZeroId, identify, track, metaMaskAddress]);
    return (_jsxs(PageLayout, __assign({ className: styles.wrapper, footer: __assign({ buttonClick: handleSubmit, actionButtonLabel: 'Next', actionButtonLoader: loading, actionButtonDisable: !address.length }, walletCreationProps) }, { children: [_jsxs("h2", __assign({ className: styles.title }, { children: ["Enter ", (toCurrency === null || toCurrency === void 0 ? void 0 : toCurrency.blockchainName) || '', " wallet address"] })), _jsxs("p", __assign({ className: styles.text }, { children: ["Your wallet is required to transfer", ' ', smartContractData ? smartContractData.name : toCurrency.name, ". Make sure your wallet is on the ", (toCurrency === null || toCurrency === void 0 ? void 0 : toCurrency.blockchainName) || '', " network. All transactions are encrypted."] })), _jsxs("div", __assign({ className: styles.input_wrapper }, { children: [_jsx(Input, { error: !!error, dataTestId: "wallet-input", autoFocus: true, label: "Wallet", value: address, placeholder: "26-35 letters and numbers", helpText: error, onChange: handleChange, disabled: Boolean(getNonEditableDefaultValue(defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.targetAddress)) }), !address && _jsx(ExtensionBtn, {})] })), _jsx(ZeroIdAgreementBlock, {})] })));
});
